import { basil } from '@spices/basil'
// import { ACLRoles, ACLResources, ACLRules } from '../models'

export default class ACLController {
  constructor({ acl = {}, store }){
    store.commit('sayl/setRoles', acl.roles)
    store.commit('sayl/setResources', acl.resources)

    acl.rules.forEach(r => {
      if(r.resources) {
        r.resources.forEach(rs => {
          basil.sayl.addRule({ access: r.access, role: r.role, resource: rs, privileges: r.privileges })
        })
      }
      else {
        basil.sayl.addRule(r)
      }
    })
  }
}
